<template>
	<div class="d-flex align-items-center">
		<span class="category-list-item-language">{{ title }} |</span>
		<CInput
			v-if="isEditing"
			v-model="input"
			class="input"
			:placeholder="defaultName"
			@keydown.esc="$emit('cancel')"
			@keydown.enter="$emit('confirm')"
		/>
		<span
			v-else
			class="category-list-item-name flex-grow-1 ml-1"
		>
			{{ slideBannerName || defaultName }}
		</span>

		<div
			v-if="slideBannerName || isEditing"
			class="category-list-item-default">{{ defaultName }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'BannerProductCategoryItem',
	props: {
		title: {
			type: String,
			default: '',
		},
		defaultName: {
			type: String,
			default: '',
		},
		slideBannerName: {
			type: String,
			default: '',
		},
		isEditing: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			input: this.slideBannerName || '',
		};
	},
	watch: {
		isEditing(isEditing) {
			if (isEditing) {
				this.input = this.slideBannerName || '';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.category-list {
		// .category-list-item
		&-item {
			// .category-list-item-language
			&-language {
				@include typo-caption-2;
			}

			// .category-list-item-name
			// .category-list-item-default
			&-name,
			&-default {
				@include typo-body-2;
				@include ellipsisOneline;
			}

			// .category-list-item-default
			&-default {
				padding: 2px 6px;
				border-radius: 6px;
				color: $color-gray-600;
				background-color: $color-gray-200;
			}
		}
	}

	.input::v-deep {
		flex-grow: 1;
		margin: 0 16px;
	}
</style>
